import { Pipe, PipeTransform, inject } from '@angular/core';
import { SpecMetaService } from '../data/data-files/spec-meta-service';

// A pure pipe would cache the pre-hydration ''.
@Pipe({ name: 'specIcon', pure: false })
export class SpecIconPipe implements PipeTransform {
  private readonly specMeta = inject(SpecMetaService);

  transform(spec: string | null | undefined): string {
    return spec ? this.specMeta.specIconUrl(spec) : '';
  }
}
